__turbopack_context__.v({
  "closeBar": "Popup-module-scss-module__DzyIeG__closeBar",
  "closeButton": "Popup-module-scss-module__DzyIeG__closeButton",
  "closeButtonLight": "Popup-module-scss-module__DzyIeG__closeButtonLight",
  "container": "Popup-module-scss-module__DzyIeG__container",
  "content": "Popup-module-scss-module__DzyIeG__content",
  "fadeIn": "Popup-module-scss-module__DzyIeG__fadeIn",
  "fadeOut": "Popup-module-scss-module__DzyIeG__fadeOut",
  "maxWidth-full": "Popup-module-scss-module__DzyIeG__maxWidth-full",
  "maxWidth-lg": "Popup-module-scss-module__DzyIeG__maxWidth-lg",
  "maxWidth-md": "Popup-module-scss-module__DzyIeG__maxWidth-md",
  "maxWidth-sm": "Popup-module-scss-module__DzyIeG__maxWidth-sm",
  "maxWidth-xl": "Popup-module-scss-module__DzyIeG__maxWidth-xl",
  "maxWidth-xs": "Popup-module-scss-module__DzyIeG__maxWidth-xs",
  "overlay": "Popup-module-scss-module__DzyIeG__overlay",
  "overlayBlur": "Popup-module-scss-module__DzyIeG__overlayBlur",
  "slideInDown": "Popup-module-scss-module__DzyIeG__slideInDown",
  "slideInRight": "Popup-module-scss-module__DzyIeG__slideInRight",
  "slideOutDown": "Popup-module-scss-module__DzyIeG__slideOutDown",
  "slideOutRight": "Popup-module-scss-module__DzyIeG__slideOutRight",
});
